import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';
import CreditCardStripeForm, {
  completeCardPayment,
} from '../../../../../02_molecules/CreditCardStripeForm';
import Button from '../../../../../01_atoms/Button';
import { RG, SD } from '../../../../../../utils/constants';
import unexpectedErrorMessage from '../../../../../../utils/unexpectedErrorMessage';
import FundraisingCosts from '../../../../../02_molecules/FundraisingCosts';
import TotalCost from '../../../../../02_molecules/TotalCost';

import styles from './index.module.scss';

const CreditCardForm = ({
  orderId = null,
  captchaToken = '',
  onSubmitForm,
  onError,
  onSuccessPayment,
  buttonType = 'primary',
  showFundraisingCosts = false,
  fundraisingCostsTooltip = '',
}) => {
  const { values } = useFormState();

  return (
    <div className={styles['credit-card-form']}>
      <div className={styles['credit-card-form__container']}>
        <div className={styles['credit-card-form__container-left']}>
          <div className={styles['credit-card-form__title']}>Debit or Credit Card</div>
          <div className={styles['credit-card-form__description']}>
            Enter your card details below
          </div>
          <CreditCardStripeForm
            orderId={orderId}
            onCompleteCardPayment={async (stripe, elements) => {
              const result = await completeCardPayment(
                stripe,
                elements,
                {
                  email: values.email.trim(),
                  name: values.payment_options.name || values.first_name,
                },
                orderId,
                values['donation_type'] === 'monthly' ? RG : SD,
                captchaToken,
              );
              if (result.type === 'error') {
                onError({
                  message: 'Sorry, we could not submit your donation.',
                  subline: unexpectedErrorMessage(),
                  additionalMessage: result.errorMessage,
                  paymentMethodId: values.payment_method_id,
                });
              } else {
                onSuccessPayment(orderId);
              }
            }}
          />

          {showFundraisingCosts &&
            values.donation_type === 'single' &&
            values.amount.single > 0 && (
              // If you are changing the condition ^, make sure it is
              // consistent with isFundraisingCostsVisible() function.
              <FundraisingCosts tooltipText={fundraisingCostsTooltip} />
            )}

          <TotalCost values={values} />

          <Button
            data-component="inline-donation-form-credit-card-submit"
            type={buttonType}
            isBlock
            className={styles['credit-card-form__submit-button']}
            onClick={onSubmitForm}
          >
            Pay with Debit or Credit Card
          </Button>
        </div>
      </div>
    </div>
  );
};

CreditCardForm.propTypes = {
  orderId: PropTypes.number,
  captchaToken: PropTypes.string,
  onSubmitForm: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessPayment: PropTypes.func.isRequired,
  buttonType: PropTypes.oneOf(['primary', 'emergency']),
  showFundraisingCosts: PropTypes.bool,
  fundraisingCostsTooltip: PropTypes.string,
};

export default CreditCardForm;
